import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { putRequest } from "utils/request";

import { i18n } from '../../../translate/i18n';
import { useNotification } from "hooks/notification";
import { getRequest } from "utils/request";

export default function TabDistribution({ companyData }) {
  const [distribute, setDistribute] = useState(false);
  const [number, setNumber] = useState(0);
  const [ticketToShow, setTicketToShow] = useState(0);
  const [needAuth, setNeedAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const { selectedCompany, addSelectedCompany } = useNotification();

  useEffect(() => {
    setLoading(true);

    const value = JSON.stringify(companyData);

    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=RETURNPAUSEPASSWORD`).then(e => {
      if(e.success) {
        if(e.data.id) {
          setNeedAuth(true);
        }
      }
    })

    if (value !== "{}") {
      if (companyData.ticketDistribute) {
        setDistribute(true);
        setNumber(companyData.ticketDistributeQuantity);
        setTicketToShow(Number(companyData.ticketShowData))
      }
      setLoading(false);
    }
  }, [companyData]);

  const handleDistribution = (e) => {
    e.preventDefault();
    setLoading(true);

    putRequest(`/companies/distribute/${companyData.id}`, {
        ticketDistribute: Boolean(distribute),
        ticketDistributeQuantity: Boolean(distribute) ? Number(number) : null,
        ticketShowData: ticketToShow,
        needAuth: needAuth
      }
    )
    .then(function () {
      setLoading(false);
        addSelectedCompany({
          ...selectedCompany, 
          ticketToShow: ticketToShow,
        })
      }
    )
  };

  if(loading) {
    return (
      <div className="area-loading">
        <CircularProgress />
      </div>
    )
  }


  return (
    <div className="list-container">
      <form onSubmit={handleDistribution}>
        <div className="form-horizontal">
          <div className="title-helper-container">
            <h3>{companyData.nickName}</h3>
          </div>
          <div className="mt-3">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="customRadio"
                className="custom-control-input"
                checked={distribute}
                onChange={(value) => setDistribute(value.target.value)}
              />
              <label className="custom-control-label" htmlFor="customRadio1">
                {i18n.t('callDistribution')}
              </label>
              <input
                type="number"
                className="form-group"
                min="0"
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  paddingLeft: 5,
                  width: "80px",
                }}
                value={distribute ? number : ""}
                onChange={(value) => setNumber(value.target.value)}
              />
              <span>{i18n.t('calls')}</span>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="customRadio"
                className="custom-control-input"
                checked={!distribute}
                onChange={(value) => setDistribute(!value.target.value)}
              />
              <label className="custom-control-label" htmlFor="customRadio2">
                {i18n.t('callNotDistribution')}
              </label>
            </div>
            <div className="custom-control custom-radio" style={{marginTop: 15, paddingLeft: 0}}>
              <label>
                {i18n.t('show')}
              </label>
              <input
                type="number"
                className="form-group"
                min="10"
                max="100"
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  paddingLeft: 5,
                  width: "80px",
                }}
                value={ticketToShow}
                onChange={(value) => setTicketToShow(value.target.value)}
              />
              <label>{i18n.t('perTimeTicket')}</label>
            </div>
            <div className="custom-control custom-radio" style={{display: 'flex', alignItems: 'center', marginTop: 5, paddingLeft: 0}}>
              <input checked={needAuth} onClick={() => setNeedAuth(!needAuth)} type="checkbox"/>
              <label style={{marginLeft: 10, marginBottom: 2}}>
                {i18n.t('returnPausePassword')}
              </label>
            </div>
          </div>

          <div
            className="button-list mt-3 pull-right"
            style={{ position: "absolute", bottom: 0, right: 0 }}
          >
            <button
              type="submit"
              className="btn btn-outline-success"
            >
              <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
